import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayCalendarNumberIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 3.25H18.75V1.75C18.75 1.34 18.41 1 18 1C17.59 1 17.25 1.34 17.25 1.75V3.25H6.75V1.75C6.75 1.34 6.41 1 6 1C5.59 1 5.25 1.34 5.25 1.75V3.25H2C1.04 3.25 0.25 4.04 0.25 5V20C0.25 21.52 1.48 22.75 3 22.75H21C22.52 22.75 23.75 21.52 23.75 20V5C23.75 4.04 22.96 3.25 22 3.25ZM22.25 20C22.25 20.69 21.69 21.25 21 21.25H3C2.31 21.25 1.75 20.69 1.75 20V9.62H22.25V20ZM22.25 8.38H1.75V5C1.75 4.86 1.86 4.75 2 4.75H22C22.14 4.75 22.25 4.86 22.25 5V8.38Z"
        fill={color}
      />
      <path
        d="M8.85001 13.07C9.30001 13.07 9.77001 13.41 9.77001 13.94C9.77001 14.53 9.50001 14.99 8.72001 15.66L6.57001 17.5V18.87H11.51V17.61H8.21001L9.51001 16.59C10.51 15.8 11.37 15.07 11.37 13.87C11.37 12.67 10.5 11.77 8.99001 11.77C7.48001 11.77 6.73001 12.58 6.42001 13.55L7.73001 14.05C7.87001 13.52 8.19001 13.07 8.85001 13.07Z"
        fill={color}
      />
      <path
        d="M15.48 14.3C14.59 14.3 14.22 14.75 13.94 15.41L14.05 13.2H17.22V11.89H12.95L12.69 15.84L13.92 16.01C14.1 15.8 14.46 15.52 15 15.52C15.65 15.52 16.05 15.96 16.05 16.6C16.05 17.28 15.68 17.77 14.96 17.77C14.24 17.77 13.85 17.33 13.55 16.79L12.46 17.65C12.88 18.36 13.6 18.99 14.95 18.99C16.67 18.99 17.63 17.94 17.63 16.52C17.63 15.1 16.67 14.3 15.48 14.3Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayCalendarNumberIcon.displayName = 'PayCalendarNumberIcon';
